module.exports = __webpack_public_path__ + "img/stock4.26f12727.png";